import React from 'react'
import styled from 'styled-components'
import { Button, Icon } from 'antd'
const DivMenu = styled.div`
  width: 100%;
  font-size: 1.5rem;
  p {
    font-size: 1rem;
  }
  span {
    font-size: 1.2rem;
  }
`
const TabTitle = styled.div`
  font-size: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  span {
    color: red;
    font-size: 1.5rem;
  }
`

const FromFinish = props => {
  const { SelectPage } = props
  return (
    <DivMenu>
      โปรโมชั่นสุดพิเศษ
      <TabTitle>
        ลงทะเบียนวันนี้ <br />
        <span>
          รับสิทธิ์แลกซื้อ <br />
          ไก่คารา คารา ชิคเก้น <br />
          ในราคา 1 บาท !!!
        </span>
      </TabTitle>
      <p>
        เพิ่มเพื่อน Line@ : @yamagoya_ramen
        <br />
        พร้อมลงทะเบียน
        <br />
        เพียงเท่านี้ก็รับสิทธิ์แลกซื้อไก่คารา คารา ชิคเก้น
        <br />
        (มูลค่า 80 บาท)
        <br />
        ได้ในราคาเพียง 1 บาท
      </p>
      <span>เริ่มแล้ววันนี้ - 31 พฤษภาคม 2562</span>
      <br />
      <Button type="primary" onClick={() => SelectPage('2')}>
        ไปหน้าลงทะเบียน
        <Icon type="right" />
      </Button>
    </DivMenu>
  )
}
export default FromFinish
